export const IMG = {
  logo: "/images/logo.webp",
  logoLight: "/images/logo-light.webp",
  heroMaster: "/images/hero_master.webp",
  heroMasterM: "/images/hero_master_m.webp",
  productUniverse: "/images/hero_master.webp",
  productUniverseM: "/images/hero_master_m.webp",
  storefront: "/images/store1.webp",
  storefrontPortrait: "/images/store2.webp",
  ripe: {
    alphonso: "/images/ripe_alphonso.webp",
    alphonsoM: "/images/ripe_alphonso_m.webp",
    strawberry: "/images/ripe_strawberry.webp",
    strawberryM: "/images/ripe_strawberry_m.webp",
    sitaphal: "/images/ripe_sitaphal.webp",
    sitaphalM: "/images/ripe_sitaphal_m.webp",
    coconut: "/images/ripe_coconut.webp",
    coconutM: "/images/ripe_coconut_m.webp",
  },
};

export const SOCIALS = [
  { label: "Instagram", handle: "@rific.india", url: "https://www.instagram.com/rific.india" },
];

export const CONTACT = {
  email: "rific.india@gmail.com",
  phoneDisplay: "+91 72492 88910",
  phoneHref: "tel:+917249288910",
  whatsapp: "https://wa.me/917249288910",
  instagram: "https://www.instagram.com/rific.india",
  instagramHandle: "@rific.india",
};
